import * as moment from 'moment';
import { isNil, isEmpty, random } from 'lodash';
import { put, takeEvery, select } from 'redux-saga/effects';

import { createCancellableSaga } from '../../../helpers';

import { StorageNames } from '../../../constants/storageNames';
import { DefaultDateFormats } from '../../../constants/dateFormats';

import { initialState } from './reducer';
import { getPagesHistoryHomeState } from './selectors';
import {
  cancelPagesHistoryHomeSaga,
  checkPagesHistoryHomeQuoteLastSeenDate,
  loadPagesHistoryHomeState,
  loadPagesHistoryHomeStateError,
  startPagesHistoryHomeSaga,
  storePagesHistoryHomeState,
  updatePagesHistoryHomeQuoteLastSeenDate,
  updatePagesHistoryHomeQuoteMessageId,
  updatePagesHistoryHomeStateFromExternalSource,
} from './actions';

import { makeGetMessagesByIdIncludes } from '../../LocaleSettings/selectors';
import { getType } from 'typesafe-actions';

function* loadHomeStateSaga() {
  try {
    const rawHomeState = localStorage.getItem(StorageNames.pagesHistoryHome) || '{}';
    let parsedHomeState = JSON.parse(rawHomeState);

    if (isNil(parsedHomeState) || isEmpty(parsedHomeState)) {
      parsedHomeState = initialState;
    }

    yield put(updatePagesHistoryHomeStateFromExternalSource(parsedHomeState));
  } catch (e) {
    yield put(loadPagesHistoryHomeStateError(e.message));
  }
}

function* storeHomeStateSaga() {
  const pagesHistoryHomeState = yield select(getPagesHistoryHomeState);
  localStorage.setItem(StorageNames.pagesHistoryHome, JSON.stringify(pagesHistoryHomeState));
}

function* checkQuoteLastSeenDateSaga() {
  const { quoteLastSeenDate } = yield select(getPagesHistoryHomeState);
  const currentDate = moment().format(DefaultDateFormats.fullDate);

  if (currentDate !== quoteLastSeenDate) {
    yield put(updatePagesHistoryHomeQuoteLastSeenDate(currentDate));
  }
}

function* updateQuoteIdSaga() {
  const getQuoteMessages = makeGetMessagesByIdIncludes('containers.PagesHistory.CreatePage.quote');
  const quoteMessageIds = Object.keys(yield select(getQuoteMessages));
  const quoteId = quoteMessageIds[random(0, quoteMessageIds.length - 1)];
  yield put(updatePagesHistoryHomeQuoteMessageId(quoteId));
  yield put(storePagesHistoryHomeState());
}

function* pagesHistoryHomeSaga() {
  yield takeEvery([getType(loadPagesHistoryHomeState)], loadHomeStateSaga);
  yield takeEvery([getType(storePagesHistoryHomeState)], storeHomeStateSaga);
  yield takeEvery([getType(checkPagesHistoryHomeQuoteLastSeenDate)], checkQuoteLastSeenDateSaga);
  yield takeEvery([getType(updatePagesHistoryHomeQuoteLastSeenDate)], updateQuoteIdSaga);
}

export default createCancellableSaga({
  START_SAGA_ACTION: getType(startPagesHistoryHomeSaga),
  CANCEL_SAGA_ACTION: getType(cancelPagesHistoryHomeSaga),
  cancellableTask: pagesHistoryHomeSaga,
});



// WEBPACK FOOTER //
// ./src/containers/PagesHistory/PagesHistoryHome/saga.ts